<template>
  <div class="bg">
    <div class="navBar">
      <img @click="leftClick()" src="../assets/ic_fanhui@2x.png" alt="" />
      <p>操作分析</p>
    </div>
    <div class="content">
      <div class="top-sy">
        <div class="leiji yuan">
          <p class="title">累计收益</p>
          <div>{{ info.profitRate }}</div>
          <p>{{ info.winMsg }}</p>
        </div>
        <div class="zhou yuan">
          <p class="title">周收益</p>
          <div>{{ info.weekProfitRate }}</div>
        </div>
        <div class="yue yuan">
          <p class="title">月收益</p>
          <div>{{ info.monthProfitRate }}</div>
        </div>
        <div class="nian yuan">
          <p class="title">年收益</p>
          <div>{{ info.yearProfitRate }}</div>
        </div>
      </div>
      <div class="grid">
        <div class="left">
          <div>
            <p class="top">{{ info.runningDay }}</p>
            <p class="bottom">运行天数</p>
          </div>
          <div>
            <p class="top">{{ info.maxProfit }}</p>
            <p class="bottom">最高收益</p>
          </div>
          <div>
            <p class="top">{{ info.successRate }}</p>
            <p class="bottom">成功率</p>
          </div>
        </div>
        <div class="right">
          <div>
            <p class="top">{{ info.shareCycle }}</p>
            <p class="bottom">平均持股周期</p>
          </div>
          <div>
            <p class="top">{{ info.returnRate }}</p>
            <p class="bottom">最大回撤</p>
          </div>
          <div>
            <p class="top">{{ info.turnoverRate }}</p>
            <p class="bottom">换手率</p>
          </div>
        </div>
      </div>
      <div class="chart">
        <div class="chart-top">
          <van-tabs
            title-active-color="#333"
            title-inactive-color="#666"
            swipe-threshold
            @click="tabClick"
            line-width="0.26rem"
          >
            <van-tab title="创建至今">
              <div class="chart-top-main">
                <div class="left">
                  <div>
                    <p class="top">{{ dataInfo.profitRate }}</p>
                    <p class="bottom">账户收益</p>
                  </div>
                  <div>
                    <p class="top">{{ dataInfo.maxProfitRate }}</p>
                    <p class="bottom">最高收益</p>
                  </div>
                </div>
                <div class="right">
                  <div>
                    <p class="top">{{ dataInfo.avgTatolAssert }}</p>
                    <p class="bottom">平均管理资金规模</p>
                  </div>
                  <div>
                    <p class="top">{{ dataInfo.returnRate }}</p>
                    <p class="bottom">最大回撤</p>
                  </div>
                </div>
              </div>
            </van-tab>
            <van-tab title="近一周">
              <div class="chart-top-main">
                <div class="left">
                  <div>
                    <p class="top">{{ dataInfo.weekProfitRate }}</p>
                    <p class="bottom">账户收益</p>
                  </div>
                  <div>
                    <p class="top">{{ dataInfo.maxWeekProfitRate }}</p>
                    <p class="bottom">最高收益</p>
                  </div>
                </div>
                <div class="right">
                  <div>
                    <p class="top">{{ dataInfo.avgWeekTatolAssert }}</p>
                    <p class="bottom">平均管理资金规模</p>
                  </div>
                  <div>
                    <p class="top">{{ dataInfo.weekReturnRate }}</p>
                    <p class="bottom">最大回撤</p>
                  </div>
                </div>
              </div>
            </van-tab>
            <van-tab title="近一月">
              <div class="chart-top-main">
                <div class="left">
                  <div>
                    <p class="top">{{ dataInfo.monthProfitRate }}</p>
                    <p class="bottom">账户收益</p>
                  </div>
                  <div>
                    <p class="top">{{ dataInfo.maxMonthProfitRate }}</p>
                    <p class="bottom">最高收益</p>
                  </div>
                </div>
                <div class="right">
                  <div>
                    <p class="top">{{ dataInfo.avgMonthTatolAssert }}</p>
                    <p class="bottom">平均管理资金规模</p>
                  </div>
                  <div>
                    <p class="top">{{ dataInfo.monthReturnRate }}</p>
                    <p class="bottom">最大回撤</p>
                  </div>
                </div>
              </div>
            </van-tab>
            <van-tab title="近三个月">
              <div class="chart-top-main">
                <div class="left">
                  <div>
                    <p class="top">{{ dataInfo.quarterProfitRate }}</p>
                    <p class="bottom">账户收益</p>
                  </div>
                  <div>
                    <p class="top">{{ dataInfo.maxQuarterProfitRate }}</p>
                    <p class="bottom">最高收益</p>
                  </div>
                </div>
                <div class="right">
                  <div>
                    <p class="top">{{ dataInfo.avgQuarterTatolAssert }}</p>
                    <p class="bottom">平均管理资金规模</p>
                  </div>
                  <div>
                    <p class="top">{{ dataInfo.quarterReturnRate }}</p>
                    <p class="bottom">最大回撤</p>
                  </div>
                </div>
              </div>
            </van-tab>
            <van-tab title="近一年">
              <div class="chart-top-main">
                <div class="left">
                  <div>
                    <p class="top">{{ dataInfo.yearProfitRate }}</p>
                    <p class="bottom">账户收益</p>
                  </div>
                  <div>
                    <p class="top">{{ dataInfo.maxYearProfitRate }}</p>
                    <p class="bottom">最高收益</p>
                  </div>
                </div>
                <div class="right">
                  <div>
                    <p class="top">{{ dataInfo.avgYearTatolAssert }}</p>
                    <p class="bottom">平均管理资金规模</p>
                  </div>
                  <div>
                    <p class="top">{{ dataInfo.yearReturnRate }}</p>
                    <p class="bottom">最大回撤</p>
                  </div>
                </div>
              </div>
            </van-tab>
          </van-tabs>
          <div class="echarts-v">
            <LineEcharts
              :lineList="LineList"
              :title="title"
              :key="menuKey"
            ></LineEcharts>
            <div></div>
          </div>
        </div>
      </div>
      <div class="pie-chart">
        <PieEcharts
          v-if="ratioList.length > 0"
          :ratioList="ratioList"
        ></PieEcharts>
      </div>
    </div>
  </div>
</template>

<script>
import { Field, Tab, Tabs } from "vant";
import api from "@/api/index";
import Vue from "vue";
import LineEcharts from "@/components/LineEcharts.vue";
import PieEcharts from "@/components/PieEcharts.vue";

let echarts = require("echarts/lib/echarts");
require("echarts/lib/chart/line");
// 以下的组件按需引入
require("echarts/lib/component/tooltip"); // tooltip组件
require("echarts/lib/component/title");
// Vue.use(VCharts);
export default {
  components: {
    [Field.name]: Field,
    [Tab.name]: Tab,
    [Tabs.name]: Tabs,
    LineEcharts,
    PieEcharts,
  },
  data() {
    this.chartSettings = {
      xAxisType: "value",
    };

    return {
      message: "",
      list: ["创建至今", "近一周", "近一月", "近三个月", "近一年"],
      info: {},
      title: "创建至今",
      ratioList: [],
      dataInfo: {},
      LineList: [],
      menuKey: 1,
      userId: "",
    };
  },
  created() {
    this.userId = localStorage.getItem("userId");
    this.getInfo();
    this.getProftLine();
    this.getProfit();
    this.getShareLayout();
  },
  methods: {
    leftClick() {
      this.$router.back(-1);
    },
    getInfo() {
      api.getTradeProfit({ accountId: this.userId }).then((res) => {
        // console.log(res);
        if (res.code == 200) {
          this.dataInfo = res.data;
        }
      });
    },
    tabClick(name, title) {
      // console.log(name, title);
      var num = "";
      if (title == "创建至今") {
        num = "";
      } else if (title == "近一周") {
        num = "2";
      } else if (title == "近一月") {
        num = "3";
      } else if (title == "近三个月") {
        num = "4";
      } else if (title == "近一年") {
        num = "6";
      }
      this.title = title;
      this.getProftLine(num);
    },
    getProftLine(num) {
      // quartarCode 不传为累计 2周 3月 4季 5半年 6年
      api
        .getProftLine({ accountId: this.userId, quartarCode: num })
        .then((res) => {
          // console.log(res);
          if (res.code == 200) {
            this.LineList = res.data.data;
            // this.info = res.data;
            ++this.menuKey;
          }
        });
    },
    getProfit() {
      api.getProfit({ accountId: this.userId }).then((res) => {
        // console.log(res);
        if (res.code == 200) {
          this.info = res.data;
        }
      });
    },
    getShareLayout() {
      api.getShareLayout({ accountId: this.userId }).then((res) => {
        console.log(res, 111);
        if (res.code == 200) {
          this.ratioList = res.data.data;
         
        }
      });
    },
    rightClick() {},
  },
};
</script>

<style lang="less" scoped>
.bg {
  width: 100%;
  background: url(../assets/bg_czfx.png) no-repeat;
  background-size: 100%;
}
.navBar {
  padding-top: 0.4rem;
  height: 0.88rem;
  display: flex;
  align-items: center;
  position: relative;
  img {
    width: 0.44rem;
    height: 0.44rem;
    padding: 0.22rem 0.3rem;
    z-index: 100;
  }
  p {
    position: absolute;
    color: #fff;
    width: 100%;
    text-align: center;
    font-size: 0.36rem;
    font-weight: bold;
  }
}
.content {
  .top-sy {
    width: 100%;
    height: 4.62rem;
    position: relative;
    text-align: center;
    p {
      font-size: 0.24rem;

      line-height: 0.34rem;
      color: #ff7945;
    }
    .leiji {
      width: 3.2rem;
      height: 3.2rem;
      position: absolute;
      top: 0.4rem;
      left: 2.14rem;
      background: #ffffff;
      .title {
        margin-top: 0.7rem;
      }
      div {
        height: 0.88rem;
        font-size: 0.72rem;
        padding: 0.08rem 0 0.16rem 0;
        font-family: Helvetica;
        color: #ff7945;
        line-height: 0.88rem;
      }
    }
    .zhou {
      width: 1.62rem;
      height: 1.62rem;
      background: rgba(255, 255, 255, 0.92);
      position: absolute;
      top: 1.14rem;
      left: 0.34rem;
      .title {
        margin-top: 0.4rem;
      }
      div {
        padding-top: 0.08rem;
        font-size: 0.36rem;
        font-family: Helvetica;
        color: #ff7945;
        line-height: 0.44rem;
      }
    }
    .yue {
      width: 1.3rem;
      height: 1.3rem;
      background: rgba(255, 255, 255, 0.92);
      position: absolute;
      top: 0.24rem;
      right: 1.02rem;
      .title {
        margin-top: 0.26rem;
      }
      div {
        padding-top: 0.08rem;
        font-size: 0.28rem;
        font-family: Helvetica;
        color: #ff7945;
        line-height: 0.34rem;
      }
    }
    .nian {
      width: 1.84rem;
      height: 1.84rem;
      background: rgba(255, 255, 255, 0.92);
      position: absolute;
      bottom: 0.2rem;
      right: 0.66rem;
      .title {
        margin-top: 0.5rem;
      }
      div {
        padding-top: 0.08rem;
        font-size: 0.4rem;
        font-family: Helvetica;
        color: #ff7945;
        line-height: 0.48rem;
      }
    }
  }
  .grid {
    margin-left: 0.32rem;
    width: 6.86rem;
    height: 4.02rem;
    background: #ffffff;
    box-shadow: 0px 0.04rem 0.24rem 0px rgba(35, 38, 42, 0.1);
    border-radius: 0.12rem;
    display: flex;
    .left {
      width: 3.2rem;
      height: 100%;
      border-right: 0.01rem solid rgba(237, 237, 237, 1);
      display: flex;
      flex-direction: column;
      div {
        height: 1.34rem;
        padding-left: 0.32rem;
        display: flex;
        flex-direction: column;
        justify-content: center;
      }
      div:nth-child(2) {
        border-top: 0.01rem solid rgba(237, 237, 237, 1);
        border-bottom: 0.01rem solid rgba(237, 237, 237, 1);
      }
    }
    .right {
      width: 3.6rem;
      height: 100%;
      display: flex;
      flex-direction: column;
      div {
        height: 1.34rem;
        padding-left: 0.3rem;
        display: flex;
        flex-direction: column;
        justify-content: center;
      }
      div:nth-child(2) {
        border-top: 0.01rem solid rgba(237, 237, 237, 1);
        border-bottom: 0.01rem solid rgba(237, 237, 237, 1);
      }
    }
  }
  .chart {
    width: 6.86rem;
    height: 7.62rem;
    background: #ffffff;
    box-shadow: 0px 0.04rem 0.24rem 0px rgba(35, 38, 42, 0.1);
    border-radius: 0.12rem;
    margin: 0.24rem 0 0 0.32rem;
    /deep/.van-tabs__nav--line {
      padding-left: 0.2rem;
      border-radius: 0.12rem;
      padding-bottom: 0.2rem;
    }
    /deep/.van-tabs__line {
      bottom: 0.37rem;
    }
    .chart-top {
      height: 3.8rem;

      // border-bottom: 0.01rem solid rgba(237, 237, 237, 1);
      .chart-top-main {
        height: 2.62rem;
        border-top: 0.01rem solid rgba(237, 237, 237, 1);
        display: flex;
      }
      .left {
        width: 3.2rem;
        height: 100%;
        border-right: 0.01rem solid rgba(237, 237, 237, 1);
        display: flex;
        flex-direction: column;
        div {
          height: 1.34rem;
          padding-left: 0.32rem;
          display: flex;
          flex-direction: column;
          justify-content: center;
        }
        div:nth-child(2) {
          border-top: 0.01rem solid rgba(237, 237, 237, 1);
          border-bottom: 0.01rem solid rgba(237, 237, 237, 1);
        }
      }
      .right {
        width: 3.6rem;
        height: 100%;
        display: flex;
        flex-direction: column;
        div {
          height:1.34rem;
          padding-left: 0.3rem;
          display: flex;
          flex-direction: column;
          justify-content: center;
        }
        div:nth-child(2) {
          border-top: 0.01rem solid rgba(237, 237, 237, 1);
          border-bottom: 0.01rem solid rgba(237, 237, 237, 1);
        }
      }
      /deep/.van-tabs--line .van-tabs__wrap {
        height: 1.16rem;
      }
      /deep/.van-tab {
        font-size: 0.28rem;
        font-weight: 500;
        padding: 0;
      }
      /deep/.van-tab--active {
        font-size: 0.36rem;
        font-weight: bold;
      }
    }
  }
  .pie-chart {
    width: 6.86rem;
    height: 8.62rem;
    background: #ffffff;
    box-shadow: 0px 0.04rem 0.24rem 0px rgba(35, 38, 42, 0.1);
    border-radius: 0.12rem;
    margin: 0.24rem 0 0.32rem 0.32rem;
  }
}
.yuan {
  border-radius: 50%;
}
.top {
  height: 0.44rem;
  font-size: 0.36rem;
  font-family: Helvetica;
  color: #333333;
  line-height: 0.44rem;
}
.bottom {
  margin-top: 0.08rem;
  height: 0.34rem;
  font-size: 0.24rem;
  font-weight: 400;
  color: #999999;
  line-height: 0.34rem;
}
.echarts-v {
  width: 100%;
  height: 3.8rem;
}
</style>